import { parseComposerReferences } from '@runloop/reflex-contract';
import { contextRefTarget } from '../components/shared/context-ref-links';

/**
 * Replace context reference markers (`@[title](kind:id)`) and expanded
 * `<referenced-context>` / `<referenced-agent-run>` blocks with their
 * canonical URLs when derivable, or the bare title otherwise. This keeps
 * the clipboard useful: pasting into Slack or a doc should give the reader
 * the original link, not an internal marker format they can't click.
 */
export function referencesToClipboardText(text: string): string {
  const segments = parseComposerReferences(text);
  if (segments.length === 1 && segments[0].type === 'text') return text;
  return segments
    .map((seg) => {
      if (seg.type === 'text') return seg.value;
      if (seg.type === 'context') {
        const target = contextRefTarget(seg.kind, seg.id);
        return target?.url ?? seg.title;
      }
      return seg.title;
    })
    .join('');
}
